import React, { useState, useEffect } from "react";
import Table from "../../../../../../../common/element/Table";
import { useSearchParams } from "react-router-dom";
import ViewResultDialog from "../../../../AdhocComapny/View/Tabs/Interview Candidate/ViewResult";
import InterviewURLModal from "./InterviewURL";
import { useSelector, useDispatch } from "react-redux";
import { selectUserData } from "../../../../../../../redux/auth/authSelector";
import {
    cancelInterviewCandidate,
    clearCancelCandidateState,
    getCandidateResult,
    clearCandidateResultState
} from "../../../../../../../redux/InterViewCandidate/interViewCandidateSlice";
import {
    selectCandidateListLoading,
    selectCancelCandidateLoading,
    selectCancelCandidateSuccess,
    selectCancelCandidateError,
    selectCancelCandidateData,
    selectCandidateResultLoading,
    selectCandidateResultError,
    selectCandidateResultData
} from "../../../../../../../redux/InterViewCandidate/interViewSelector";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import CommonModal from "../../../../../../../common/Common/CommonModal";
import SweetAlertService from "../../../../../../../common/SweetAlert/SweetAlert";
import { formatToolName } from "../../../../../../../common/Formatters.js/formatters";
import CommonIconButton from "../../../../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const ChevronUp = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 15L12 9L6 15" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ChevronDown = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const InterViewCandidateList = ({
    sampleData = [],
    onView: _onView,
    onEdit: _onEdit,
    isLoading = false,
    onRefresh,
    companyData,
    currentPage = 1,
    pageLimit = 10
}) => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const companyId = searchParams.get("companyId");

    const [expandedRows, setExpandedRows] = useState(new Set());
    const [openResultDialog, setOpenResultDialog] = useState(false);
    const [openInterviewURLModal, setOpenInterviewURLModal] = useState(false);
    const [isOpen, setIsopen] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [selectedCandidateForURL, setSelectedCandidateForURL] = useState(null);

    const userData = useSelector(selectUserData);
    const candidateListLoading = useSelector(selectCandidateListLoading);
    const cancelCandidateLoading = useSelector(selectCancelCandidateLoading);
    const cancelSuccess = useSelector(selectCancelCandidateSuccess);
    const cancelError = useSelector(selectCancelCandidateError);
    const cancelData = useSelector(selectCancelCandidateData);
    const resultLoading = useSelector(selectCandidateResultLoading);
    const resultData = useSelector(selectCandidateResultData);
    const resultError = useSelector(selectCandidateResultError);

    const loading = isLoading || candidateListLoading;

    const getSerialNumber = (index) => {
        const serialNumber = (currentPage - 1) * pageLimit + index + 1;
        return String(serialNumber).padStart(2, "0");
    };

    const toggleRow = (index) => {
        setExpandedRows(prev => {
            const next = new Set(prev);
            if (next.has(index)) next.delete(index);
            else next.add(index);
            return next;
        });
    };

    useEffect(() => {
        if (cancelSuccess && cancelData) {
            SweetAlertService.showSuccess({
                title: "Success!",
                message: cancelData?.message || cancelData?.msg || "Candidate cancelled successfully!",
            });
            if (onRefresh) onRefresh();
            dispatch(clearCancelCandidateState());
        }
    }, [cancelSuccess, cancelData, dispatch, onRefresh]);

    useEffect(() => {
        if (cancelError) {
            const errorMessage = cancelError?.message || cancelError?.msg || cancelError || "Failed to cancel candidate!";
            SweetAlertService.showError({
                title: "Error!",
                message: typeof errorMessage === 'string' ? errorMessage : "Failed to cancel candidate!",
            });
            dispatch(clearCancelCandidateState());
        }
    }, [cancelError, dispatch]);

    useEffect(() => {
        if (resultError) {
            const errorMessage = resultError?.message || resultError?.msg || resultError || "Failed to fetch candidate result!";
            SweetAlertService.showError({
                title: "Error!",
                message: typeof errorMessage === 'string' ? errorMessage : "Failed to fetch candidate result!",
            });
        }
    }, [resultError]);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed': return 'bg-green-100 text-green-700';
            case 'upcoming': return 'bg-[#D2EBFF] text-blue-700';
            case 'cancelled': return 'bg-red-100 text-red-700';
            case 'pending': return 'bg-yellow-100 text-yellow-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const handleViewResult = (session) => {
        setSelectedCandidate(session);
        setOpenResultDialog(true);
        if (session.candidate_id || session.id) {
            dispatch(getCandidateResult({
                company_id: Number(companyId),
                candidate_id: session.candidate_id || session.id
            }));
        }
    };

    const handleOpenURLModal = (session) => {
        setSelectedCandidateForURL(session);
        setOpenInterviewURLModal(true);
    };

    const handleDeleteClick = (session) => {
        setSelectedCandidate(session);
        setIsopen(true);
    };

    const handleDelete = async () => {
        if (selectedCandidate) {
            try {
                await dispatch(cancelInterviewCandidate({
                    company_id: Number(companyId),
                    candidate_id: selectedCandidate.candidate_id || selectedCandidate.id
                })).unwrap();
                setIsopen(false);
                setSelectedCandidate(null);
            } catch (error) {
                console.error("Failed to cancel candidate:", error);
                setIsopen(false);
                setSelectedCandidate(null);
            }
        } else {
            SweetAlertService.showError({ title: "Error!", message: "Missing Candidate ID or Company ID" });
        }
    };

    const handleCloseDeleteModal = () => {
        setIsopen(false);
        setSelectedCandidate(null);
    };

    const handleCloseResultDialog = () => {
        setOpenResultDialog(false);
        setSelectedCandidate(null);
        dispatch(clearCandidateResultState());
    };

    const isCancelDisabled = (status) => {
        const isCompanyActive = companyData?.hasOwnProperty('company_isActive')
            ? companyData?.company_isActive
            : userData?.company_isActive;
        if (!isCompanyActive) return true;
        return ['completed', 'cancelled'].includes(status?.toLowerCase());
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <Tr>
                    <Td colSpan={6} className="text-center text-gray-500 py-6 text-sm">
                        <ThreeDotBouncingLoader />
                    </Td>
                </Tr>
            );
        }

        if (sampleData?.length > 0) {
            return sampleData.map((item, index) => {
                const isExpanded = expandedRows.has(index);
                const sessions = item.sessions || [];

                return (
                    <React.Fragment key={index}>
                        {/* Main candidate row */}
                        <Tr
                            className="cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={() => toggleRow(index)}
                        >
                            <Td className="text-start">
                                <div className="flex items-center gap-2">
                                    {isExpanded ? <ChevronUp /> : <ChevronDown />}
                                    <span>{getSerialNumber(index)}</span>
                                </div>
                            </Td>
                            <Td className="text-start font-medium text-gray-800">{item.name}</Td>
                            <Td className="text-start text-gray-600">{item.email}</Td>
                            <Td className="text-start text-gray-600">{sessions.length}</Td>
                            <Td className="text-start text-gray-600">{formatDate(item.interview_date)}</Td>
                            <Td></Td>
                        </Tr>

                        {/* Sub-header row — uses same Tr/Td so columns auto-align */}
                        {isExpanded && (
                            <Tr style={{ background: '#FFF4E5' }}>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>S No.</Td>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>Tools Name</Td>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>Status</Td>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>Interview Date</Td>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>Submission Date</Td>
                                <Td className="text-start text-sm font-semibold text-gray-600 whitespace-nowrap" style={{ background: '#FFF4E5' }}>Action</Td>
                            </Tr>
                        )}

                        {/* Session data rows — same Tr/Td structure */}
                        {isExpanded && sessions.length > 0 && sessions.map((session, sIdx) => (
                            <Tr key={session.candidate_id || sIdx} style={{ background: '#FFFAF5' }}>
                                <Td className="text-start text-sm text-gray-700" style={{ background: '#FFFAF5' }}>
                                    {String(sIdx + 1).padStart(2, '0')}
                                </Td>
                                <Td className="text-start text-sm text-gray-700" style={{ background: '#FFFAF5' }}>
                                    {formatToolName(session.tool?.tool || '-')}
                                </Td>
                                <Td className="text-start" style={{ background: '#FFFAF5' }}>
                                    <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(session.status)}`}>
                                        {session.status || '-'}
                                    </span>
                                </Td>
                                <Td className="text-start text-sm text-gray-700" style={{ background: '#FFFAF5' }}>
                                    {formatDate(session.interview_date || "--")}
                                </Td>
                                <Td className="text-start text-sm text-gray-700" style={{ background: '#FFFAF5' }}>
                                    {formatDate(session.submission_date)}
                                </Td>
                                <Td className="text-start" style={{ background: '#FFFAF5' }}>
                                    <div className="flex gap-2 items-center">
                                        {session.status === "completed" && (
                                            <CommonIconButton
                                                type="view"
                                                onClick={() => handleViewResult(session)}
                                            />
                                        )}
                                        {session.status === "completed" || session.status === "cancelled" ? (
                                            <CommonIconButton
                                                type="link"
                                                onClick={() => handleOpenURLModal(session)}
                                                disabled
                                                label={`Link disabled: assessment ${session.status === 'completed' ? 'completed' : 'cancelled'}`}
                                            />
                                        ) : (
                                            <CommonIconButton
                                                type="link"
                                                onClick={() => handleOpenURLModal(session)}
                                            />
                                        )}
                                        {isCancelDisabled(session.status) ? (
                                            <CommonIconButton type="disablecancel" label="Cancel Disabled" disabled />
                                        ) : (
                                            <CommonIconButton type="cancel" label="Cancel Candidate" onClick={() => handleDeleteClick(session)} />
                                        )}
                                    </div>
                                </Td>
                            </Tr>
                        ))}

                        {isExpanded && sessions.length === 0 && (
                            <Tr>
                                <Td colSpan={6} className="text-center text-gray-400 py-3 text-sm" style={{ background: '#FFFAF5' }}>
                                    No tools assigned
                                </Td>
                            </Tr>
                        )}
                    </React.Fragment>
                );
            });
        }

        return (
            <Tr>
                <Td colSpan={6} className="text-center text-gray-500 py-6 text-sm">
                    No matching records found
                </Td>
            </Tr>
        );
    };

    return (
        <div className="border rounded-lg border-gray-200">
            <Table>
                <THead>
                    <Tr className="text-start">
                        <Th className="text-start">S No.</Th>
                        <Th className="text-start">Candidate Name</Th>
                        <Th className="text-start">Email Address</Th>
                        <Th className="text-start">Number of Tool</Th>
                        <Th className="text-start">Interview Date</Th>
                        <Th className="text-start"></Th>
                    </Tr>
                </THead>
                <TBody>
                    {renderTableBody()}
                </TBody>
            </Table>

            <ViewResultDialog
                dialogOpen={openResultDialog}
                onDialogClose={handleCloseResultDialog}
                candidateData={selectedCandidate}
                resultData={resultData}
                isLoading={resultLoading}
                error={resultError}
            />

            <InterviewURLModal
                onDialogClose={() => {
                    setOpenInterviewURLModal(false);
                    setSelectedCandidateForURL(null);
                }}
                dialogOpen={openInterviewURLModal}
                onSubmit={() => setOpenInterviewURLModal(false)}
                candidateData={selectedCandidateForURL}
            />

            <CommonModal
                dialogOpen={isOpen}
                onDialogClose={handleCloseDeleteModal}
                onConfirm={handleDelete}
                title="Are you sure you want to cancel?"
                subtitle="This action cannot be undone."
                isLoading={cancelCandidateLoading}
            />
        </div>
    );
};

export default InterViewCandidateList;
